module.exports = __webpack_public_path__ + "static/media/logo_pickpockie_(1).b5eca72c.png";